module.exports = __webpack_public_path__ + "static/img/eureka_icon_4.361222ac.png";